import type { UseFormReturn } from 'react-hook-form';
import { Checkbox, Labeled, TextInputField } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IIapPollFormValues } from './IapPollForm';
import { FormDateField } from '~/components/atoms/fields/DateField';
import { FormField } from '~/components/atoms/FormField';
import { FormSection } from '~/components/atoms/FormSection';
import { IapPollFormMainSectionOptions } from './IapPollFormMainSectionOptions';

export type IIapPollFormMainSectionProps = IContainerProps & {
  form: UseFormReturn<IIapPollFormValues>;
  mode: IFormMode;
};

export const IapPollFormMainSection: React.FC<IIapPollFormMainSectionProps> = (
  props,
) => {
  const { sx, form } = props;
  const { t } = useTranslation();

  return (
    <FormSection sx={sx}>
      <Labeled label={t('IapPollFormMainSection.fields.title.label')} required>
        <FormField
          as={TextInputField}
          forwardError
          control={form.control}
          name="title"
        />
      </Labeled>

      <Labeled label={t('IapPollFormMainSection.fields.description.label')}>
        <FormField
          as={TextInputField}
          forwardError
          control={form.control}
          name="description"
        />
      </Labeled>

      <Labeled
        label={t('IapPollFormMainSection.fields.options.label')}
        required
      >
        <IapPollFormMainSectionOptions form={form} mode={props.mode} />
      </Labeled>

      <Labeled
        label={t('IapPollFormMainSection.fields.startDate.label')}
        required
      >
        <FormDateField name="startDate" control={form.control} />
      </Labeled>

      <Labeled
        label={t('IapPollFormMainSection.fields.endDate.label')}
        required
      >
        <FormDateField name="endDate" control={form.control} />
      </Labeled>

      <Labeled
        label={t('IapPollFormMainSection.fields.displayResults.label')}
        supportingText={t(
          'IapPollFormMainSection.fields.displayResults.supportingText',
        )}
        labelPosition="right"
      >
        <FormField name="displayResults" control={form.control} as={Checkbox} />
      </Labeled>
    </FormSection>
  );
};
